import {writable} from 'svelte/store';

let membersObject = {
    list: null,
    total: 0,
    selectedId: null,
    page: 1,
    memberIsDirty: false,

    search: {
        name: null,
        email: null,
        status: '',
        limit: 50,
        offset: 0,
        sort_field: null,
        sort_way: null,
    },

    changed: false,
    scrollY: null,
};

const {get, set, update, subscribe} = writable(membersObject);

const members = {
    set,
    update,
    subscribe,

    clearSearch: () => {
        members.update(obj => {
            obj.search.name = null;
            obj.search.email = null;
            obj.search.status = '';
            obj.search.offset = 0;

            obj.page = 1;
            return obj;
        });
    }
}

export default members;